var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-aside-tab clearfix"},_vm._l((_vm.views),function(ref,index){
var iconName = ref.iconName;
var viewName = ref.viewName;
return _c('div',{key:index,staticClass:"wx-aside-tab-container",on:{"click":function($event){_vm.viewChange(viewName)}}},[_c('i',{staticClass:"iconfont wx-aside-tab-container__icons",class:[iconName,{'is-active' : viewName === _vm.currentView}]})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7ba4756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Tab.vue
// module id = null
// module chunks = 